import { APIS } from '~constants/index';
import type { ErrorDetail } from '~store/useStore';
import { sendRequest } from '~utils/index';
import type { CatchError } from '~utils/sendRequest';

export const logout = (refresh_token: string, clearAppStorage: () => void) => {
  sendRequest<unknown>({
    url: APIS.LOGOUT,
    method: 'post',
    type: 'public',
    data: { refresh_token },
    thenFunction: () => clearAppStorage(),
    catchFunction: (error) => {
      const errorObtained = error as CatchError;
      const errorDetail = errorObtained.response.data as ErrorDetail;
      if (errorDetail?.detail === 'Token is invalid or expired') {
        clearAppStorage();
      }
    }
  });
};

